enum PropertyTypeOptions {
  APARTMENT = 1,
  HOUSE,
  FLAT,
  CONDOMINIUM_HOUSE,
}

export default PropertyTypeOptions;
